export type ResourceErrorKind = 'not-found' | 'failed'

const NOT_FOUND_STATUS = 404
const NOT_FOUND_MESSAGE = /not\s*found|n[aã]o\s+encontrad/i

/**
 * O interceptor do axios rejeita com o corpo da resposta (`{code, message}`) mais
 * `httpStatus`. O backend nem sempre manda 404 (ex.: "Product not found with id [N]"
 * ja veio com outro status), entao a mensagem tambem conta.
 */
export function isNotFoundError(error:any):boolean {
    if (!error) {
        return false
    }

    if (error.httpStatus === NOT_FOUND_STATUS || Number(error.code) === NOT_FOUND_STATUS) {
        return true
    }

    return typeof error.message === 'string' && NOT_FOUND_MESSAGE.test(error.message)
}

export function getResourceErrorKind(error:any):ResourceErrorKind {
    return isNotFoundError(error) ? 'not-found' : 'failed'
}
